import type { TutorialVideo } from "./types";

interface TutorialCardProps {
  tutorial: TutorialVideo;
}

export const TutorialCard = ({ tutorial }: TutorialCardProps) => {
  return (
    <article className="rounded-xl border border-border bg-card p-4 shadow-sm">
      <video
        className="mb-4 h-auto w-full rounded-lg bg-black object-contain"
        controls
        playsInline
        preload="metadata"
        poster={tutorial.posterUrl}
        src={tutorial.videoUrl}
      >
        Your browser does not support the video tag.
      </video>
      <div className="mb-2">
        <span className="inline-flex rounded-full bg-primary-subtle px-2 py-1 text-xs font-semibold text-primary-emphasis">
          {tutorial.category}
        </span>
      </div>
      <h3 className="text-lg font-semibold text-foreground">{tutorial.title}</h3>
      <p className="mt-2 text-sm text-muted-foreground">{tutorial.description}</p>
    </article>
  );
};
